<template>
  <div class="page-container">
    <el-card>
      <div class="action-bar">
        <el-button v-permission="['system:menu:create']" type="success" size="mini" icon="el-icon-plus" @click="handleCreate(null)">新建</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
        <el-button size="mini" icon="el-icon-sort" @click="toggleExpand">{{ isExpand ? '收起' : '展开' }}全部</el-button>
      </div>

      <el-table
        ref="menuTable"
        :data="menuTree"
        v-loading="loading"
        row-key="id"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :default-expand-all="isExpand"
      >
        <el-table-column label="菜单标题" min-width="180">
          <template slot-scope="{ row }">
            <i :class="row.icon || (row.type === 2 ? 'el-icon-key' : 'el-icon-document')" style="margin-right: 4px" />
            {{ row.title }}
          </template>
        </el-table-column>
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.type === 1 ? 'primary' : 'warning'" size="small">
              {{ row.type === 1 ? '菜单' : '按钮' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="路由名称" width="140" />
        <el-table-column prop="path" label="路由路径" min-width="160" />
        <el-table-column prop="component" label="组件" min-width="160" />
        <el-table-column prop="permission" label="权限标识" min-width="160" />
        <el-table-column prop="sort" label="排序" width="70" align="center" />
        <el-table-column label="状态" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="row.type === 1" v-permission="['system:menu:create']" type="success" size="mini" icon="el-icon-plus" @click="handleCreate(row)">子菜单</el-button>
            <el-button v-permission="['system:menu:update']" type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
            <el-button v-permission="['system:menu:delete']" type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px" @close="resetForm">
      <el-form ref="menuForm" :model="form" :rules="rules" label-width="90px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="菜单类型" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio :label="1">菜单</el-radio>
                <el-radio :label="2">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="父级菜单">
              <el-cascader
                v-model="form.parent_id_path"
                :options="menuOptions"
                :props="{ value: 'id', label: 'title', children: 'children', checkStrictly: true, emitPath: true }"
                clearable
                filterable
                placeholder="顶级菜单"
                style="width: 100%"
                @change="handleParentChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="菜单标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入显示标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路由名称">
              <el-input v-model="form.name" placeholder="英文，如: UserManage" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 1" :gutter="16">
          <el-col :span="12">
            <el-form-item label="路由路径">
              <el-input v-model="form.path" placeholder="/system/user" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组件路径">
              <el-input v-model="form.component" placeholder="system/user/index" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="图标">
              <el-input v-model="form.icon" placeholder="el-icon-xxx">
                <i v-if="form.icon" slot="prefix" :class="form.icon" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="权限标识">
              <el-input v-model="form.permission" placeholder="system:user:list" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input-number v-model="form.sort" :min="0" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否隐藏">
              <el-switch v-model="form.hidden" active-text="是" inactive-text="否" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialog.visible = false">取消</el-button>
        <el-button type="primary" size="mini" :loading="dialog.loading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenuList, createMenu, updateMenu, deleteMenu } from '@/api/menu'

export default {
  name: 'MenuManage',
  data() {
    return {
      loading: false,
      menuTree: [],
      menuOptions: [],
      isExpand: true,
      dialog: { visible: false, title: '', loading: false },
      form: { id: null, parent_id: 0, parent_id_path: [], name: '', title: '', path: '', component: '', icon: '', sort: 0, type: 1, permission: '', hidden: false, status: 1 },
      rules: {
        title: [{ required: true, message: '菜单标题不能为空', trigger: 'blur' }],
        type: [{ required: true }]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getMenuList()
        const list = res.data || []
        this.menuTree = this.buildTree(list)
        this.menuOptions = this.buildMenuOptions(list)
      } finally {
        this.loading = false
      }
    },
    buildTree(list, parentId = 0) {
      const children = list.filter(item => item.parent_id === parentId)
      return children.map(item => ({
        ...item,
        children: this.buildTree(list, item.id)
      })).sort((a, b) => a.sort - b.sort)
    },
    buildMenuOptions(list) {
      const menuOnly = list.filter(item => item.type === 1)
      return [{ id: 0, title: '顶级菜单', children: this.buildTree(menuOnly) }]
    },
    toggleExpand() {
      this.isExpand = !this.isExpand
      this._toggleAllRows(this.menuTree, this.isExpand)
    },
    _toggleAllRows(rows, expand) {
      rows.forEach(row => {
        this.$refs.menuTable && this.$refs.menuTable.toggleRowExpansion(row, expand)
        if (row.children && row.children.length) {
          this._toggleAllRows(row.children, expand)
        }
      })
    },
    handleParentChange(val) {
      this.form.parent_id = val && val.length ? val[val.length - 1] : 0
    },
    handleCreate(parent) {
      this.form = {
        id: null,
        parent_id: parent ? parent.id : 0,
        parent_id_path: parent ? [parent.id] : [],
        name: '', title: '', path: '', component: '',
        icon: '', sort: 0, type: 1, permission: '', hidden: false, status: 1
      }
      this.dialog = { visible: true, title: parent ? `新增「${parent.title}」的子菜单` : '新增根菜单', loading: false }
    },
    handleEdit(row) {
      this.form = {
        ...row,
        parent_id_path: row.parent_id ? [row.parent_id] : []
      }
      this.dialog = { visible: true, title: '编辑菜单', loading: false }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除「${row.title}」？如有子菜单需先删除。`, '提示', { type: 'warning' })
        await deleteMenu({ id: row.id })
        this.$message.success('删除成功')
        this.fetchData()
      } catch {}
    },
    handleSubmit() {
      this.$refs.menuForm.validate(async valid => {
        if (!valid) return
        this.dialog.loading = true
        const payload = { ...this.form }
        delete payload.parent_id_path
        try {
          if (payload.id) {
            await updateMenu(payload)
            this.$message.success('更新成功')
          } else {
            await createMenu(payload)
            this.$message.success('创建成功')
          }
          this.dialog.visible = false
          this.fetchData()
        } finally {
          this.dialog.loading = false
        }
      })
    },
    resetForm() {
      this.$refs.menuForm && this.$refs.menuForm.resetFields()
    }
  }
}
</script>
